<template>
  <div class="fond">
    <div class="login-form-wrapper">
      <app-login-form></app-login-form>
    </div>

    <div class="center-logo">
      <img src="../../assets/Arystote.png" alt="" />
    </div>
  </div>
</template>

<script>
import LoginForm from '../../components/login/LoginForm.vue'
export default {
  components: {
    appLoginForm: LoginForm
  }
}
</script>
<style lang="scss">
.fond {
  background-image: url("../../assets/Fond.jpg");
  background-size: cover;
  position: relative;
  height: 100vh;
}
.center-logo {
  width: 540px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  img {
    max-width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/PageLogin/index.vue